export const DirectionCoordsConstants = {
    GET_DIRECTIONCOORDS: 'GET_DIRECTIONCOORDS',
    SET_DIRECTIONCOORDS: 'SET_DIRECTIONCOORDS'
};